import { TableConfig } from 'src/app/shared/components/generic-table';
import { TrackingRegistryView } from './services/list-individual.facade';
import { dateToUserTimezone } from 'src/app/helpers/date-utils';
import { DateFormat } from 'src/app/shared/enums/date-formats.enum';
import { ThousandsMaskPipe } from 'src/app/shared/pipes/thousands-mask.pipe';

export type ListIndividualColumnKeys =
  | keyof TrackingRegistryView
  | '_icon'
  | '_wallets'
  | '_actions';

export const LIST_INDIVIDUAL_NO_DATA_MESSAGE = $localize`:@@noDataDisplay:No hay datos para mostrar.`;

const thousandMask = new ThousandsMaskPipe();

export const getListIndividualTableConfig = (): TableConfig<
  TrackingRegistryView,
  ListIndividualColumnKeys
> => ({
  columns: [
    {
      id: '_icon',
      title: $localize`:@@js_type:Tipo`,
      hasCustomContent: true,
      minWidth: '50px',
      maxWidth: '50px',
    },
    {
      id: 'name',
      title: $localize`:@@js_name:Nombre`,
      hasCustomContent: true,
      width: '1fr',
      minWidth: '120px',
    },
    {
      id: 'document',
      title: $localize`:@@js_document:Documento`,
      hasCustomContent: true,
      maxWidth: '135px',
      minWidth: '95px',
    },
    {
      id: '_wallets',
      title: $localize`:@@walletsIndividual:Carteras`,
      hasCustomContent: true,
      maxWidth: '120px',
      minWidth: '85px',
      textAlign: 'center',
    },
    {
      id: 'internalCode',
      title: $localize`:@@internalCode:Código Interno`,
      hasCustomContent: true,
      maxWidth: '150px',
      minWidth: '120px',
    },
    {
      id: 'segment',
      title: $localize`:@@segment:Segmento`,
      hasCustomContent: true,
      maxWidth: '150px',
      minWidth: '120px',
    },
    {
      id: 'score',
      title: 'Score',
      maxWidth: '110px',
      minWidth: '90px',
      textAlign: 'center',
      getValue: (row) => (row.score ? thousandMask.transform(row.score) : '-'),
    },
    {
      id: 'totalRestrictive',
      title: $localize`:@@restrictiveQty:Cantidad restrictiva`,
      hasCustomContent: true,
      maxWidth: '130px',
      minWidth: '95px',
      textAlign: 'center',
    },
    {
      id: 'inclusionDate',
      title: $localize`:@@inclusionDate:Fecha de inclusión`,
      maxWidth: '136px',
      minWidth: '100px',
      textAlign: 'center',
      getValue: (row) => dateToUserTimezone(row.inclusionDate, DateFormat.DATE),
    },
    {
      id: '_actions',
      title: $localize`:@@actions:Acciones`,
      hasCustomContent: true,
      maxWidth: '110px',
      minWidth: '95px',
      textAlign: 'center',
    },
  ],
  trackByProp: ['id'],
  rowIdFn: (row: TrackingRegistryView) => String(row.id)
});

export const listIndividualTableConfig = getListIndividualTableConfig();
